const numberFormats = {
  'en-au': {
    currency: {
      style: 'currency',
      currency: 'AUD'
    }
  },
  'en-ca': {
    currency: {
      style: 'currency',
      currency: 'CAD'
    }
  },
  'en-gb': {
    currency: {
      style: 'currency',
      currency: 'GBP'
    }
  },
  'en-nz': {
    currency: {
      style: 'currency',
      currency: 'NZD'
    }
  },
  'en-us': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  }
}

export default numberFormats
